import query from '../graphql/nav-query.js'

import Cookies from 'js-cookie';
import queryCurrentPage from '../graphql/get-current-page.js';

export default () => ({
	loaded: false,
	nav: false,
	// flatNav: [],
	seenBanner: Cookies.get('seen_banner'),
	breadcrumbs: window.breadcrumbs,
	sidebarEl: document.getElementById('sidebar'),
	sidebarHidden: true,
	sidebarTheme: false,
	currentPage: false,
	index: false,
	openAccordionIds: [],
	currentChapterIndex: 0,
	currentPageChapterIndex: window.currentPageChapterIndex || 0,
	chapterNav: false,
	videoActive: false,
	videoSrc: false,
	videoRatio: "a16-9",
	searchActive: false,
	mobileDirectory() {
		if(this.searchActive) {
			this.searchActive = false
		}
		if(this.videoActive) {
			this.videoActive = false
		}
		if(this.getWindowSize()) {
			this.sidebarHidden = !this.sidebarHidden;
		}
	},
	openDirectory() {
		if(this.searchActive) {
			this.searchActive = false
		}
		if(this.videoActive) {
			this.videoActive = false
		}
		this.sidebarHidden = !this.sidebarHidden
		if(this.sidebarHidden === 'true'){ 
			this.sidebarBtn = 'Menu';
		} else {
			this.sidebarBtn = 'Hide Menu';
		}
	},
	toggleChapterNav(item, index) {
		this.sidebarEl.scrollTo(0,0);
		this.chapterNav = !this.chapterNav;
		if (item && index) {
			this.currentChapterIndex = index;
			this.sidebarTheme = 'theme-' + item.page.theme.value;
		}
	},
	getWindowSize() {
		return matchMedia('(max-width: 1024px)').matches;
	},
	hideBanner() {
		this.seenBanner = true
		// Uncomment below to enable cookie and expire after 1 day
		Cookies.set('seen_banner', 'true', { expires: 1 })
	},
	openAccordion(entryId = false){
		if (entryId) {
			if (!this.openAccordionIds.includes(entryId)) {
				this.openAccordionIds.push(entryId)	
			}
		}
	},
	closeAccordion(entryId = false){
		if (entryId) {
			if (this.openAccordionIds.includes(entryId)) {
				this.openAccordionIds = this.openAccordionIds.filter(id => id !== entryId)
			}
		}
	},
	toggleAccordion(entryId = false) {
		if (entryId) {
			if (this.openAccordionIds.includes(entryId)) {
				this.openAccordionIds = this.openAccordionIds.filter(id => id !== entryId)
			} else {
				this.openAccordionIds.push(entryId)
			}
		}
		
	},
	scrollToAccordion(entrySlug = false) {
		let accordionSlug = false
		if (entrySlug) {
			accordionSlug = entrySlug
		} else {
			accordionSlug = window.location.hash.replace('#', '')
		}

		let accordionEl = document.querySelector(`[data-slug="${accordionSlug}"]`)
		if (accordionEl) {
			window.scrollTo({
				top: (accordionEl.offsetTop - 100),
				behavior: 'smooth'
			})
		}
	},
	loadModalVideo(attrs) {
		this.videoActive =	true
		this.videoSrc = attrs.src
		this.videoRatio = attrs.ratio
	},
	fetchNav() {
		fetch('/graphql', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				query: query
			}),
		})
		.then((res) => res.json())
		.then((result) => {
			let nav = result.data.nav.tree;
			let code = result.data.collection.structure.tree;

			nav.forEach((item, index) => {
				if(item.page.url === "code-of-practice") {
					nav.splice(index, 1)
					let navIndex = index;
					code.forEach((item) => {
						nav.splice(navIndex, 0, item)
						navIndex++;
					})
				}
			})
			this.nav = nav;
			// this.flattenArray(nav)
			this.setActiveStates();
			this.toggleAccordion()
			this.scrollToAccordion()
		})
	},
	// flattenArray(arr) {
	// 	arr.forEach((a) => {
	// 		if (a.children) {
	// 			this.flatNav.push(a)
	// 			this.flattenArray(a.children)
	// 		} else {
	// 			this.flatNav.push(a)
	// 		}
	// 	})
	// },
	setActiveStates() {
		let root = this.nav.find((item, index) => {
			if (item.page.id === this.breadcrumbs[1]) {
				if (item.page.collection && item.page.collection.handle == "code_of_practice") {
					this.toggleChapterNav(item, index);
				}
				return item
			}
		})

		if (root && root.children) {
			root.children.forEach((child) => {
				if (child.page.id === this.breadcrumbs[2]) {
					child.page.active = true;
				}
			})
		}
	},
	init() {
		this.loaded = true
		if (!this.getWindowSize()) {
			this.sidebarHidden = false;
		}
		this.fetchNav();
		window.addEventListener('resize', this.getWindowSize);
		window.addEventListener('page-load', (e) => {
			this.currentPage = e.detail.pageId;
			this.breadcrumbs = JSON.parse(e.detail.breadcrumbs);
		})
		window.Alpine.effect(() =>
			document.documentElement.classList.toggle(
				"overflow-y-hidden",
				this.searchActive || !this.seenBanner || (!this.sidebarHidden && this.getWindowSize()) || this.videoActive
			)
		);
	},
});
